import { hot } from 'react-hot-loader/root';
import React, { Suspense } from 'react';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@sunbit-dev/purchase-common/src/theme/ThemeProvider';
import { GlobalStyle } from '@sunbit-dev/purchase-common/src/theme/globalStyle';
import { Router } from 'react-router-dom';
import { store } from '~/store/store';
import { defaultTheme } from '~/theme';
import { customHistory } from '~/utilities/customerHistory/customerHistory';
import { ApplicationLayout } from './components/applicationLayout/ApplicationLayout';
import { ErrorBoundaryContainer } from './components/errorBoundaries/ErrorBoundaries';
import { PopupProvider } from './components/popupProvider/PopupProvider';
import { ActivityTracking } from '~/components/app/components/activityTracking/ActivityTracking';
import { Loader } from '@sunbit-dev/purchase-common/src/components/loader/Loader';
import { LogsTracking } from '~/components/app/components/logsTracking/LogsTracking';
import { MainContent } from './components/mainContent/MainContent';

const App = () => {
  return (
    <Router history={customHistory}>
      <Suspense fallback={<Loader contained />}>
        <PopupProvider>
          <Provider store={store}>
            <ThemeProvider extendTheme={defaultTheme}>
              <GlobalStyle />
              <LogsTracking />
              <ErrorBoundaryContainer>
                <ActivityTracking>
                  <ApplicationLayout>
                    <MainContent />
                  </ApplicationLayout>
                </ActivityTracking>
              </ErrorBoundaryContainer>
            </ThemeProvider>
          </Provider>
        </PopupProvider>
      </Suspense>
    </Router>
  );
};

export default hot(App);
